import React from "react";
import { useTheme } from "@/lib/uiTheme";

// Motivul din colțul plăcilor de start: cuburi izometrice în trepte, estompate spre stânga și jos; nuanțele urmează aspectul
// (Purple: mov și roz; Fiord: turcoaz și albastru-verzui).
const R = 13, DX = 0.866 * R;
const COLUMNS = [1, 1, 2, 2, 3, 4, 4];          // înălțimea (în cuburi) a fiecărei coloane, de la stânga la dreapta
const PALETTES = {
  purple: [
    ["#E8C9F7", "#C98BEA", "#8B35D6"],          // sus, stânga, dreapta
    ["#F6C5DD", "#E08BB4", "#C23B7E"],
    ["#EBD7FA", "#C9A0EC", "#7C2BD0"],
  ],
  fiord: [
    ["#CFEDEE", "#7FCFD1", "#0B7F81"],
    ["#D8EBF3", "#8DBFD3", "#2B6E8C"],
    ["#E1F3F2", "#9AD5D0", "#0F9A94"],
  ],
};

function cube(cx, cy, key, s) {
  const p = (pts) => pts.map(([x, y]) => `${x.toFixed(1)},${y.toFixed(1)}`).join(" ");
  return (
    <g key={key}>
      <polygon points={p([[cx, cy - R], [cx + DX, cy - R / 2], [cx, cy], [cx - DX, cy - R / 2]])} fill={s[0]} />
      <polygon points={p([[cx - DX, cy - R / 2], [cx, cy], [cx, cy + R], [cx - DX, cy + R / 2]])} fill={s[1]} />
      <polygon points={p([[cx, cy], [cx + DX, cy - R / 2], [cx + DX, cy + R / 2], [cx, cy + R]])} fill={s[2]} />
    </g>
  );
}

export default function TileArt() {
  const SHADES = PALETTES[useTheme()] || PALETTES.purple;
  const cubes = [];
  COLUMNS.forEach((h, i) => {
    const cx = 52 + i * 2 * DX, base = 150 - R - i * (R * 0.5);
    for (let k = 0; k < h; k++) cubes.push(cube(cx, base - k * R * 1.5 + (k ? 0 : 0), `${i}-${k}`, SHADES[(i + k) % SHADES.length]));
  });
  return (
    <svg className="tile-art" viewBox="0 0 230 150" aria-hidden="true" preserveAspectRatio="xMaxYMax meet">
      <defs>
        <linearGradient id="taFadeL" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stopColor="#fff" stopOpacity="1" /><stop offset=".62" stopColor="#fff" stopOpacity="0" /></linearGradient>
        <linearGradient id="taFadeB" x1="0" y1="0" x2="0" y2="1"><stop offset=".55" stopColor="#fff" stopOpacity="0" /><stop offset="1" stopColor="#fff" stopOpacity=".9" /></linearGradient>
      </defs>
      <g opacity=".9">{cubes}</g>
      <rect x="0" y="0" width="230" height="150" fill="url(#taFadeL)" />
      <rect x="0" y="0" width="230" height="150" fill="url(#taFadeB)" />
    </svg>
  );
}
